module.exports = __webpack_public_path__ + "static/media/carouselimg2.4445a8f7.png";